/**
 * Usuario comprador referencial (debajo del código) + almacén si es limitado.
 * Nombres largos se recortan con ellipsis; el título muestra el nombre completo.
 */
function shortenLabel(value, max = 16) {
  const text = String(value || '').trim();
  if (!text) return '';
  if (text.length <= max) return text;
  return `${text.slice(0, max - 1).trimEnd()}…`;
}

export default function BuyerUserCell({ creator, className = 'mt-0.5', maxLen = 16 }) {
  if (!creator?.name) return null;

  const isLimited = creator.role === 'limitado';
  const warehouseLabel = isLimited
    ? (creator.warehouses || [])
        .map((w) => w?.name)
        .filter(Boolean)
        .join(', ')
    : '';

  const nameShort = shortenLabel(creator.name, maxLen);
  const warehouseShort = warehouseLabel ? shortenLabel(warehouseLabel, maxLen) : '';

  return (
    <div className={className}>
      <div className="text-xs text-gray-500 leading-snug whitespace-nowrap" title={creator.name}>
        {nameShort}
      </div>
      {warehouseShort ? (
        <div className="text-[11px] text-gray-400 leading-snug whitespace-nowrap" title={warehouseLabel}>
          {warehouseShort}
        </div>
      ) : null}
    </div>
  );
}
